import { vm } from "./config/instance";
import router, { store } from "./config/router";
import "moment/locale/zh-cn";

// global components
import "./config/components";
// iconfont
import "@/assets/fonts/iconfont/iconfont.css";
// style
// import 'ant-design-vue/dist/antd.less'
import "ant-design-vue/dist/antd.css";
import "@/assets/styles/theme.less";
import "@/assets/styles/antd.less";
import "@/assets/styles/init.less";
import "@/assets/styles/common.less";

// antd
import Antd, { notification, message } from "ant-design-vue";
// import 'ant-design-vue/dist/antd.css'

notification.config({
  placement: process.env.NODE_ENV == "prod" ? "bottomRight" : "bottomLeft",
  bottom: "10px",
  duration: 3,
});
message.config({
  top: "70px",
});

vm.use(store).use(router).use(Antd).mount("#root");
